import axios from 'axios';
import server_config from '../../ServerConfiguration';

const node_server_address = server_config["node_server_address"];

export const fetchMediaLibrary = async () => {
    let response = { 'success': false };
    response = await axios({
        method: 'POST',
        //url: server_address + ':' + ports["master_server"] + '/',
        url: node_server_address,
        timeout: 5000,
        data: { "functionid": "retrievemedialibrary", "libraryfunction": "axios" },
    }).then(async (resp) => {
        return resp.data;
    }).catch(async (error) => { });
    if (response.success) {
        return new Promise(resolve =>
            resolve({ data: response.storedMediaLibrary })
        )
    }
}

export const updateMediaLibrary = async (newMediaLibrary) => {
    let response = { 'success': false };
    console.log("updateMediaLibrary")
    console.log(newMediaLibrary)
    response = await axios({
        method: 'POST',
        //url: server_address + ':' + ports["master_server"] + '/',
        url: node_server_address,
        timeout: 5000,
        data: { "functionid": "changemedialibrary", "newMediaLibrary": newMediaLibrary, "libraryfunction": "axios" }
    })
    .then(async (resp) => { return resp.data; })
    .catch(async (error) => {
        console.log("FAILURE of updateMediaLibrary")
        console.log(error);
    });
    if (response.success) {
        return new Promise(resolve => resolve({ data: response.success}))
    }

}
